import { faFileImport } from "@fortawesome/pro-regular-svg-icons";
import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { useInputDialog } from "src/components/common/dialogs/input/useInputDialog.tsx";
import { FeeliaLeanSystemInventoryEventApi } from "src/api/generated/tenants/feelia/leanSystem/api/feeliaLeanSystemInventoryEventApi.ts";
import { useAavoToast } from "src/components/common/toast/AavoToastContext";
import { uploadFile } from "src/utils/fileUploading";

export const FeeliaLeanSystemInventoryLevelEventImportButton = () => {
	const showInputDialog = useInputDialog();
	const { showToast } = useAavoToast();

	return (
		<AsyncMenuButton
			key={"feeliaLeanSystemInventoryLevelEventImportButton"}
			icon={faFileImport}
			label={"Tuo varastotapahtumat Leanista"}
			onClick={async () => {
				const file = await showInputDialog({
					type: "singleFile",
					title: "Lataa varastotapahtumat",
					fieldLabel: "Tiedosto",
					required: true,
					defaultValue: null
				});

				if (file === undefined) return;
				const fileHandle = await uploadFile(file)

				await FeeliaLeanSystemInventoryEventApi.importInventoryEvents({
					fileHandle: fileHandle,
				});

				showToast({ message: "Varastotapahtumat ladattu onnistuneesti" });
			}}
		/>
	);
};
